/**
 * Test IDs for QA automation.
 */
export const testIds = {
  bestBuyRankingListResetRanking: "best-buy-ranking-list-reset-ranking",
} as const;
